export const FALLBACK_IMG =
	' https://producer.tixologi.com/static/media/createTicket.6abcfb938eb0b2f68bbe099361c25602.svg';
